<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div :class="{ 'blur-content': this.isLoading }">
      <div class="main-wrapper">
        <!--begin::sidebar-->
        <sidebar-component classMenu="TransportOrderCt"></sidebar-component>
        <!--end::sidebar-->

        <div class="page-wrapper">
          <!--begin::navbar-->
          <navbar-component></navbar-component>
          <!--end::navbar-->

          <!--begin::content-->
          <div class="page-content">

            <!-- <div>
              <h4 style="margin-right: 5px" class="float-start"></h4>
              <h4 class="mb-12 mb-md-0">
                Checklist P2H
              </h4>
              <br />
            </div> -->

            <br>
            <ul class="nav nav-tabs nav-tabs-line" id="lineTab" role="tablist">
              <!-- <li class="nav-item">
                <a class="nav-link" id="new-line-tab" data-bs-toggle="tab" href="#new" role="tab" aria-controls="new"
                  aria-selected="false">NEW<span class="badge bg-danger">
                    {{ totalNew }}
                  </span></a>
              </li> -->

              <li class="nav-item">
                <a class="nav-link" id="accept-line-tab" data-bs-toggle="tab" href="#accept" role="tab"
                  aria-controls="accpet" aria-selected="true">ACCEPT<span class="badge bg-danger">
                    {{ totalAccept }}
                  </span></a>
              </li>

              <li class="nav-item">
                <a class="nav-link" id="valid-line-tab" data-bs-toggle="tab" href="#valid" role="tab"
                  aria-controls="valid" aria-selected="false">VALID <span class="badge bg-danger">
                    {{ totalValid }}
                  </span></a>
              </li>

              <li class="nav-item">
                <a class="nav-link" id="invalid-line-tab" data-bs-toggle="tab" href="#invalid" role="tab"
                  aria-controls="invalid" aria-selected="false">INVALID <span class="badge bg-danger">
                    {{ totalInvalid }}
                  </span></a>
              </li>


              <li class="nav-item">
                <a class="nav-link" id="retake-line-tab" data-bs-toggle="tab" href="#retake" role="tab"
                  aria-controls="retake" aria-selected="false">RETAKE <span class="badge bg-danger">
                    {{ totalRetake }}
                  </span></a>
              </li>

              <li class="nav-item">
                <a class="nav-link" id="retake-line-tab" data-bs-toggle="tab" href="#history" role="tab"
                  aria-controls="history" aria-selected="false">HISTORY <span class="badge bg-danger">
                    {{ totalHistory }}
                  </span></a>
              </li>





              <li class="nav-item ">
                <h5 style="margin-top:10px;margin-right: 5px">Choose Date : </h5>
              </li>
              <li class="nav-item ">
                <date-range-picker style="width: 100%" control-container-class="form-control" :locale-data="locale"
                  v-model="dateFilter" :opens="opens" :singleDatePicker="false" :timePicker24Hour="true"
                  :timePicker="true" :showWeekNumbers="false">
                </date-range-picker>

              </li>
              <li class="nav-item">
                <!-- <button class="btn btn-warning float-end btn-sm" style="margin-left: 5px"
                @click="loadItems()">
                  Go
                </button> -->

                <button class="btn btn-warning float-end btn-sm" style="margin-left: 5px"
                  @click.prevent="filterDateRange">
                  Go
                </button>


              </li>
            </ul>




            <div class="tab-content mt-3" id="lineTabContent">
              <!-- <div class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-line-tab">
                <template-table :date-range="dateFilter" :status="'NEW'"
                  @passDataNew="getDataNew($event)"></template-table>
              </div> -->


              <div class="tab-pane fade show active" id="accept" role="tabpanel" aria-labelledby="accept-line-tab">

                <template-table :date-range="dateFilter" :status="'ACCEPT'"
                  @passDataAccept="getDataAccept($event)"></template-table>
                <!-- <transport-assigned-view :date-range="dateFilter" :status="'Accept'"
                  @passDataAssigned="getDataAssigned($event)"
                  @show_order="getOrderNo($event)"></transport-assigned-view> -->
              </div>
              <div class="tab-pane fade" id="valid" role="tabpanel" aria-labelledby="valid-line-tab">

                <template-table :date-range="dateFilter" :status="'VALID'"
                  @passDataValid="getDataValid($event)"></template-table>

                <!-- <transport-rejected-view :date-range="dateFilter" :status="'REJECTED'"
                  @passDataRejected="getDataRejected($event)"
                  @show_order="getOrderNo($event)"></transport-rejected-view> -->
              </div>
              <div class="tab-pane fade" id="invalid" role="tabpanel" aria-labelledby="invalid-line-tab">

                <template-table :date-range="dateFilter" :status="'INVALID'"
                  @passDataInValid="getDataInvalid($event)"></template-table>
                <!-- <transport-completed-view :date-range="dateFilter" :status="'COMPLETED'"
                  @passDataCompleted="getDataCompleted($event)"
                  @show_order="getOrderNo($event)"></transport-completed-view> -->
              </div>



              <div class="tab-pane fade" id="retake" role="tabpanel" aria-labelledby="retake-line-tab">

                <template-table :date-range="dateFilter" :status="'RETAKE'"
                  @passDataRetake="getDataRetake($event)"></template-table>
                <!-- <transport-completed-view :date-range="dateFilter" :status="'COMPLETED'"
                  @passDataCompleted="getDataCompleted($event)"
                  @show_order="getOrderNo($event)"></transport-completed-view> -->
              </div>


               <div class="tab-pane fade" id="history" role="tabpanel" aria-labelledby="history-line-tab">

                <template-table :date-range="dateFilter" :status="'HISTORY'"
                  @passDataHistory="getDataHistory($event)"></template-table>
                <!-- <transport-completed-view :date-range="dateFilter" :status="'COMPLETED'"
                  @passDataCompleted="getDataCompleted($event)"
                  @show_order="getOrderNo($event)"></transport-completed-view> -->
              </div>





            </div>






          </div>
          <!--end::content-->




          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import templateTable from "@/components/orders/control-tower/checklistp2h/templateTable.vue"
// import ModalApproveChecklistP2H from "@/components/modal/modalApproveChecklistP2H.vue";
//import Datepicker from "vuejs-datepicker";

import DateRangePicker from "vue2-daterange-picker";
import moment from 'moment';

export default {
  name: "ChecklistP2hIndex",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    "template-table": templateTable,
    //Datepicker,
    DateRangePicker,
  },
  data() {
    const startDate = moment().subtract(1, 'day').format('YYYY-MM-DD'); // H-1
    const endDate = moment().add(1, 'day').format('YYYY-MM-DD'); // H+1

    return {
      totalHistory:0,
      totalRetake:0,
      totalNew: 0,
      totalAccept: 0,
      totalValid: 0,
      totalInvalid: 0,
      datas: "",
      actions: "",
      showModalApprove: false,
      rowsSelection: [],
      transport_order_header_ids: [],
      selectOnCheckboxOnly: false,
      opens: "center",
      locale: {
        format: "yyyy-mm-dd",
      },
      showModalRecap: false,
      dataModal: {},
      maxToasts: 100,
      filtertanggal: new Date(),
      dateFilter: {
        startDate,
        endDate,
      },
      position: "up right",
      closeBtn: true,
      isLoading: false,
      errors: [],
      permision_role: [],
      langs: ["id", "en"],
      detailUser: [],
      detailDivisi: [],
      totalRecords: 0,
      serverParams: {
        // columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },

      rows: [],
    };
  },
  watch: {},
  computed: {
  },
  methods: {

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == 'ChecklistP2HController') {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_custom1) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

      if (this.$route.query.msg) {
        if (this.$route.query.status == 200) {
          this.success(this.$route.query.msg)
        } else {
          this.error(this.$route.query.msg)
        }

      }

    },


    getDataNew(res) {
      this.totalNew = res;
    },
    getDataValid(res) {
      this.totalValid = res;
    },

    getDataInvalid(res) {
      this.totalInvalid = res;
      console.log(this.totalInvalid);
    },

    getDataRetake(res) {
      this.totalRetake = res;
      console.log(this.totalRetake);
    },

    getDataHistory(res) {
      this.totalHistory = res;
      console.log(this.totalHistory);
    },


    getDataAccept(res) {
      this.totalAccept = res;
    },



    formatNumber(value) {
      //console.log(value);
      return parseInt(value).toLocaleString();
    },

    closeMyModal() {
      this.showModalApprove = false;
      this.loadItems();
    },

    approveModalApprove() {

      this.showModalApprove = true;
    },

    editData(row) {
      this.showModalApprove = true;
      this.datas = row;
      this.actions = "Edit";
    },

    detailData(row) {
      this.showModalApprove = true;
      this.datas = row;
      this.actions = "Detail";
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },
    sendOrder() { },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
    },

    cancelOrder() {

    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    acceptOrder(row) {
      this.transport_order_header_ids = [row.transport_order_header_id]
      this.showModalApprove = true;
    },

    rejectOrder(row) {
      this.transport_order_header_ids = [row.transport_order_header_id]
      this.showModalApprove = true;
    },


    downloadData() {
      let dataSend = {
        start: moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD'), //this.dateFilter.startDate,  // moment(String(this.forms.join_date)).format('YYYY-MM-DD');
        end: moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD'),
      };

      var startDate = dataSend.start;
      var endDate = dataSend.end;
      var pick_plan = startDate + '~' + endDate;

      var dest_plan = '';
      if (this.serverParams.columnFilters.dest_plan != '') {
        dest_plan = this.$moment(this.serverParams.columnFilters.dest_plan).format("YYYY-MM-DD");
      }
      var invalid_params = "";
      if (this.$route.query.p2h_cheklist_result) {
        invalid_params = "&p2h_checklist_result=INVALID";
      }

      //let tanggal = this.filtertanggal.toISOString().split('T')[0]
      this.isLoading = true;
      const baseURI = this.$settings.endPoint + `control-tower/transport-order-header/p2h-checklist?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&pick_plan=${pick_plan}&vehicle_no=${this.serverParams.columnFilters.vehicle_no}&dest_plan=${dest_plan}&pick_name=${this.serverParams.columnFilters.pick_name}&dest_name=${this.serverParams.columnFilters.dest_name}&type_truck=${this.serverParams.columnFilters.type_truck}&driver_id=${this.serverParams.columnFilters.driver_id}&driver_name=${this.serverParams.columnFilters.driver_name}&load_id=${this.serverParams.columnFilters.load_id}&shipwith_ref=${this.serverParams.columnFilters.shipwith_ref}&branch_name=${this.serverParams.columnFilters.branch_name}&payable=${this.serverParams.columnFilters.payable}&job_external=${this.serverParams.columnFilters.job_external}&p2h_checklist_result=${this.serverParams.columnFilters.p2h_checklist_result}&accept_time=${this.serverParams.columnFilters.accept_time}&p2h_approval=${this.serverParams.columnFilters.p2h_approval}${invalid_params}&download=download`;

      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_report_checklistp2h" + CurrentDate + ".xlsx";

      //var columnFilters = this.serverParams.columnFilters;


      return this.$http
        .get(
          baseURI,
          {
            responseType: "blob",
          }
        )
        .then((response) => {

          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },


    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },



    updateFormatDate(date) {
      let date_format = this.$moment(date).format("dd mmm yyyy");
      return date_format;
    },



    viewData(row) {
      var params = this.$onRandom(row.transport_order_header_id);
      this.$root.$router.push({
        path: `/ct-orders/pod-form-view/` + params,
      })
      // var params = this.$onRandom(row.transport_order_header_id);
      // window.location.href = "/ct-orders/edit/" + params;
    },


    selectionChanged(ev) {

      this.rowsSelection = [];
      this.transport_order_header_ids = [];

      this.rowsSelection = ev.selectedRows;

      this.rowsSelection.forEach((item) => {

        this.transport_order_header_ids.push(item.transport_order_header_id);


      });






    },


    newData() {
      let dataSend = {
        start: moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD'), //this.dateFilter.startDate,  // moment(String(this.forms.join_date)).format('YYYY-MM-DD');
        end: moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD'),
      };
      this.$root.$router.push({
        path: `/ct-orders/pod-form-create?start=${dataSend.start}&end=${dataSend.end}`,
      })
      //   window.location.href = "/absensidriver";
    },




    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    filterDateRange() {
      this.showMaps = false;
      var start = moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD hh:mm:ss');
      var end = moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD hh:mm:ss');
      this.dateFilter = {
        startDate: start,
        endDate: end
      }
    },

    success2(msg) {
      // let pesan="";
      // msg.forEach((item) => {
      //     pesan=pesan+"<p>* "+item+"</p>";
      // });

      this.$swal({
        icon: 'info',
        backdrop: true,
        title: "Information",
        html: msg,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })


    },

    loadingSubmiting() {

      this.$swal({
        icon: 'warning',
        backdrop: true,
        title: "Please wait",
        html: '<h2>SUBMITTING ORDER...</h2>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },

  },
  events: {},
  created: function () { },
  mounted() {
    this.fetchIt();
    this.loading();



  },
};
</script>
<style scoped>
.blur-content {
  filter: blur(5px);
  pointer-events: none;
}

.card-body {
  padding: 5px 1.5rem 1rem;
}

.vgt-table th {
  text-align: left !important;
}

.toggleFilterClass {
  display: none !important;
}
</style>